import { AppDispatch } from '..';
import apis from '../../utils/apis';
import logger from '../../utils/logger';

/**
 * Fetch the aggregated dashboard summary from the backend.
 * Dispatches FETCH_DASHBOARD_REQUEST → SUCCESS | FAILURE.
 */
export const fetchDashboardSummary = () => async (dispatch: AppDispatch) => {
  dispatch({ type: 'FETCH_DASHBOARD_REQUEST' });
  try {
    const response = await apis.get('/dashboard/summary');
    dispatch({ type: 'FETCH_DASHBOARD_SUCCESS', payload: response.data });
  } catch (error: any) {
    const message = error?.response?.data?.error || 'Failed to load dashboard';
    logger.error('[DASHBOARD] Fetch failed', { error: message });
    dispatch({ type: 'FETCH_DASHBOARD_FAILURE', payload: message });
  }
};

/**
 * Optimistically mark a task as completed from the dashboard.
 * Removes the task from urgentTasks and decrements overview counts.
 */
export const completeDashboardTask = (taskUuid: string) => {
  return { type: 'DASHBOARD_COMPLETE_TASK', payload: taskUuid };
};
